module.exports = __webpack_public_path__ + "assets/img/c609-gl.svg";